import Vue from "vue";
import Vuex from "vuex";
import site, { namespace as siteNamespace } from "./modules/site";
import user, { namespace as userNamespace } from "./modules/user/user";
import portal, { namespace as portalNamespace } from "./modules/portal/portal";
import portalInformation, { namespace as portalInformationNamespace } from "./modules/portal/portal-information";
import portalHyperlinks, { namespace as portalHyperlinksNamespace } from "./modules/portal/portal-hyperlinks";
import newsArticle, { namespace as newsArticleNamespace } from "./modules/newsArticle/newsArticle";
import settings, { namespace as settingsNamespace } from "./modules/settings/settings";
import contentItem, { namespace as contentItemNamespace } from "./modules/contentItems/contentItems";
import favorite, { namespace as favoriteNamespace } from "./modules/favorite/favorite";
import searchFeedback, { namespace as searchFeedbackNamespace } from "./modules/searchFeedback/search-feedback";
import suggestions, { namespace as suggestionsNamespace } from "./modules/suggestions/suggestions";
import contentItemsFilters, { namespace as contentItemsFiltersNamespace } from "./modules/contentItems/contentItemsFilters";
import apps, { namespace as appsNamespace } from "./modules/apps/apps";
import subscription, { namespace as subscriptionsNamespace } from "./modules/subscriptions/subscriptions";
import tasks, { namespace as tasksNamespace } from "./modules/tasks/tasks";
import teams, { namespace as teamsNamespace } from "./modules/teams/teams";
import hyperlinks, { namespace as hyperlinksNamespace } from "./modules/hyperlinks/hyperlinks";
import collections, { namespace as collectionsNameSpace } from "./modules/collections/collections";
import document, { namespace as documentNamespace } from "./modules/document/document";
import pendingDocumentComments, { namespace as pendingDocumentCommentsNamespace } from "./modules/document/pendingDocumentComments";
import readList, { namespace as readListNamespace } from "./modules/readList/read-list";
import notifications, { namespace as notificationsNamespace } from "./modules/notifications/notifications";
import glossary, { namespace as glossaryNamespace } from "./modules/glossary";
import timeZone, { namespace as timeZonesNamespace } from "./modules/timeZones/timeZones";
import features, { namespace as featuresNamespace } from "./modules/features/features";
import aiSearch, { namespace as aiSearchResultsNamespace } from "./modules/ai/aiSearch";
import aiBrowse, { namespace as aiBrowseNamespace } from "./modules/ai/aiBrowse";

Vue.use(Vuex);

export interface RootState {}

const modules = {};

modules[siteNamespace] = site;
modules[userNamespace] = user;
modules[portalNamespace] = portal;
modules[newsArticleNamespace] = newsArticle;
modules[portalInformationNamespace] = portalInformation;
modules[portalHyperlinksNamespace] = portalHyperlinks;
modules[newsArticleNamespace] = newsArticle;
modules[settingsNamespace] = settings;
modules[contentItemNamespace] = contentItem;
modules[favoriteNamespace] = favorite;
modules[searchFeedbackNamespace] = searchFeedback;
modules[suggestionsNamespace] = suggestions;
modules[appsNamespace] = apps;
modules[subscriptionsNamespace] = subscription;
modules[tasksNamespace] = tasks;
modules[contentItemsFiltersNamespace] = contentItemsFilters;
modules[documentNamespace] = document;
modules[pendingDocumentCommentsNamespace] = pendingDocumentComments;
modules[readListNamespace] = readList;
modules[teamsNamespace] = teams;
modules[hyperlinksNamespace] = hyperlinks;
modules[collectionsNameSpace] = collections;
modules[notificationsNamespace] = notifications;
modules[notificationsNamespace] = notifications;
modules[glossaryNamespace] = glossary;
modules[timeZonesNamespace] = timeZone;
modules[featuresNamespace] = features;
modules[aiSearchResultsNamespace] = aiSearch;
modules[aiBrowseNamespace] = aiBrowse;

export default new Vuex.Store<RootState>({
    state: <RootState>{},
    mutations: {},
    actions: {},
    modules: modules
});
